export default {
    routerName: 'ロール詳細',
    role: {
        name: 'ロール名',
        code: 'コード',
        authority: '権限',
        sortOrder: 'ソート',
        status: '状態',
        open: '有効',
        close: '無効',
        createBy: '作成者',
        createTime: '作成日付',
        updateBy: '更新者',
        updateTime: '更新日付',
        remark: '備考',
    },
    menu: {
        menuDistribute: '配分',
    },
};
